module.exports = __webpack_public_path__ + "static/media/banner-3.4662357e.png";